/**
 * Created by jonas on 2021-02-02.
 */

import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {IRockBottomGameData, IRockBottomInitData} from "./data/IRockBottomData";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {RockBottomParsedInitData} from "./data/RockBottomParsedInitData";
import {RockBottomParsedGameData} from "./data/RockBottomParsedGameData";
import {RockBottomDataParser} from "./data/RockBottomDataParser";
import {RockBottom} from "../RockBottom";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class RockBottomModel extends GameModel<IRockBottomInitData, IRockBottomGameData> {

    public parsedInitData:RockBottomParsedInitData;
    public parsedGameData:RockBottomParsedGameData;
    public reels:string[][];
    public isRestore:boolean = false;
    public nextPlayerInteraction: any;

    private _parser:RockBottomDataParser;

    constructor(api:ApiPlugin, triggerEvents:boolean = true) {
        super(api, triggerEvents);
        this._parser = new RockBottomDataParser();
    }

    protected onInit(data:IRockBottomInitData):void {
        this.parsedInitData = new RockBottomParsedInitData(data, this._parser);
        this.reels = this.parsedInitData.reels;
        this.isRestore = data.isRestoreState;
        this.nextPlayerInteraction = data.nextPlayerInteraction;
        super.onInit(data);
    }

    protected onGame(data:IRockBottomGameData):void {
        console.log("onGameModel", data);
        this.parsedGameData = new RockBottomParsedGameData(data, this._parser);
        this.reels = this.parsedGameData.reels;
        this.isRestore = false;
        super.onGame(data);
    }
}